import { Navigate, useLocation } from 'react-router-dom'

import { isChatbotRoutePath } from '~/features/chatbot/utils'
import useGetAuthSessionQuery from '~/hooks/useGetAuthSessionQuery'
import { EClientPath } from '~/models/api'
import { store } from '~/store'

function AuthRedirectConfig() {
  const { pathname } = useLocation()
  const [setUser, user] = store((state) => [state.setUser, state.user])
  const { data: authSession } = useGetAuthSessionQuery()

  if (user.signInRedirectPath && authSession?.cognitoUid && user.isValidated) {
    // if there is a tab open with an active chat conversation, don't redirect if user signs in from another tab
    if (!isChatbotRoutePath(pathname)) {
      return <Navigate to={user.signInRedirectPath} />
    }

    setUser({ signInRedirectPath: null })
  }

  // If user is logged in and on login page, redirect to overview

  if (
    authSession?.cognitoUid &&
    user.isValidated &&
    pathname === EClientPath.login
  ) {
    return <Navigate to={EClientPath.overview} replace />
  }
}

export default AuthRedirectConfig
